import { render } from "./add-edit-investigation-modal.html?vue&type=template&id=4cd7c8c0&scoped=true&ts=true&external"
import script from "./add-edit-investigation-modal.ts?vue&type=script&lang=ts&external"
export * from "./add-edit-investigation-modal.ts?vue&type=script&lang=ts&external"

import "./add-edit-investigation-modal.scss?vue&type=style&index=0&id=4cd7c8c0&scoped=true&lang=sccs&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd7c8c0"]])

export default __exports__